/// <reference types="@angular/localize" />

// main.ts
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Loader } from '@googlemaps/js-api-loader';
import { AppModule } from './app/app.module'; // Import AppModule
import { environment } from './environments/environment'; //

// Services use google.maps synchronously (e.g. MapService field initializers),
// so the Maps API must be loaded with the environment key before bootstrapping.
// Options must match the Loader in SharedModule/HomeModule.
const mapsLoader = new Loader({
  apiKey: environment.googleMapsApiKey,
  version: 'weekly',
});

Promise.all([
  mapsLoader.importLibrary('maps'),
  mapsLoader.importLibrary('marker'),
  mapsLoader.importLibrary('routes'),
  mapsLoader.importLibrary('drawing').catch(err => console.error('Google Maps drawing library failed to load', err)),
])
  .catch(err => console.error('Google Maps failed to load', err))
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err));
